import {
  ChartsXReferenceLineProps,
  ChartsReferenceLineProps,
} from "@mui/x-charts-premium";
import { useMemo } from "react";
import { DurationSeries } from "firefly-shared-ts-timeseries";
import { alpha, useTheme } from "@mui/material";
import { useResolveMaxTemperatureReferenceLineProps } from "./useResolveMaxTemperatureReferenceLineProps";
import { useResolveAvgMaxTemperatureReferenceLineProps } from "./useResolveAvgMaxTemperatureReferenceLineProps";
import { FlueBurnMetricAggregates } from "../../../chimney/flue/metrics/FlueBurnMetricAggregates";
import { DateTime } from "luxon";

const unit = "°C";
export const useChartsReferenceLines = (
  flueBurnMetricAggregates: FlueBurnMetricAggregates,
  durationSeries: Array<DurationSeries<number | null>> | undefined,
  selectedMonth?: DateTime
): Array<ChartsReferenceLineProps> => {
  const theme = useTheme();
  const ignitionEndTime = useMemo(() => {
    if (durationSeries == null || durationSeries.length === 0) {
      return undefined;
    }

    return durationSeries[0].firstPoint?.duration.plus({ minutes: 15 });
  }, [durationSeries]);

  const maxTemperatureReferenceLineProps =
    useResolveMaxTemperatureReferenceLineProps(
      flueBurnMetricAggregates,
      unit,
      selectedMonth
    );

  const avgMaxTemperatureReferenceLineProps =
    useResolveAvgMaxTemperatureReferenceLineProps(
      flueBurnMetricAggregates,
      unit,
      selectedMonth
    );

  return useMemo(() => {
    let lines: Array<ChartsReferenceLineProps> = [];
    if (ignitionEndTime !== undefined) {
      lines.push({
        x: ignitionEndTime?.toMillis(),
        lineStyle: {
          stroke: alpha(theme.palette.divider, 0.2),
        },
      } as ChartsXReferenceLineProps);
    }
    if (maxTemperatureReferenceLineProps.length > 0) {
      lines = lines.concat(maxTemperatureReferenceLineProps);
    }
    if (avgMaxTemperatureReferenceLineProps.length > 0) {
      lines = lines.concat(avgMaxTemperatureReferenceLineProps);
    }
    return lines;
  }, [
    avgMaxTemperatureReferenceLineProps,
    ignitionEndTime,
    maxTemperatureReferenceLineProps,
    theme.palette.divider,
  ]);
};
